import React from 'react';
import Floating from "../../common/Floating";
import FadeSlideIn from "../../common/FadeSlideIn";
import landing from "../../../resources/landingPrimary.png";
import landingRewards from "../../../resources/landingPrimaryRewards.png";
import scrollIcon from "../../../resources/scrollIcon.png";
import {NavLink} from "react-router-dom";

const LandingHero = () => {
    return (<FadeSlideIn>
        <div className="landingHeader">
            <div className="heroIntro">
                <div className="heroBanner">
                    <img src={landing} alt=""/>
                    <img src={landingRewards} alt="" className={"landingRewardsImage"}/>
                </div>
                <div className="heroSponsored">
                    From small wins to big rewards, our program has something for everyone at every step of the way!
                </div>
                <div className="heroButtons">
                    <NavLink to={"rewards"} className="btn btn-kaz">CLAIM BONUSES</NavLink>
                    <NavLink to={"leaderboard"} className="btn btn-normal">LEADERBOARD</NavLink>
                </div>

            </div>
            <div className="heroRewards">
                EXPLORE THE PLATFORM
                <Floating style={{marginBottom: 25}}>
                    <img src={scrollIcon} alt=""/>
                </Floating>
            </div>
        </div>
    </FadeSlideIn>);
}
export default LandingHero;